import React, { Component } from "react";
import axios from "axios";
import { HomeSlider, HomeTitle, FlightItem } from "../../Components/UI/UI";

import { getWeather } from "../../Utility/Utility";
import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";
import "./LiveLandingBoard.css";

class LiveLandingBoard extends Component {
  state = {
    flights: [],
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount = async () => {
    try {
      const res = await axios.get(
        "https://data.gov.il/api/3/action/datastore_search?resource_id=e83f763b-b7d7-479e-b172-ae981ddc6de5"
      );
      // console.log('res' , res.data.result.records);
      this.setState({ flights: res.data.result.records });
    } catch (err) {
      console.log(err);
    }
  };

  setCurrentFlights = (id) => {
    const flights = [...this.state.flights];
    const current = flights.find((o) => {
      return o.id === id;
    });
    if (current.isOpen === true) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      flights: flights,
    });
  };

  componentDidMount() {
    getWeather((Weather) => {
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    //  const flightsHtml= this.state.flights.map((o)=>{
    //     console.log('o' , o);
    //   return <FlightItem q={o.q} answer={o.answer} isOpen={o.isOpen} click={ () => {
    //     this.setCurrentFlights(o.id);
    //   }} />

    // });
    return (
      <div className="page align-center page-Flight-Board inner-page">
        <Menu />
        <HomeSlider
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />
        <div class="container">
          <HomeTitle>Live Landing Board</HomeTitle>
          <div className="clear"></div>

          <div className="flight-board-wrapper">
            <table>
              <thead>
                <th>Airline Company</th>
                <th>Flight</th>
                <th>Coming From</th>
                <th>Terminal</th>
                <th>Scheduled Time</th>
                <th>
                  Estimated <br /> Time
                </th>
                <th>Status</th>
              </thead>
              <tbody>
                {this.state.flights.length ? (
                  this.state.flights.map((flight) => (
                    <tr key={flight._id}>
                      <td>{flight.CHOPERD}</td>
                      <td>
                        {flight.CHOPER}-{flight.CHFLTN}
                      </td>
                      <td>{flight.CHLOC1T}</td>
                      <td>{flight.CHTERM}</td>
                      <td>
                        <strong>{flight.CHSTOL.slice(11, 16)}</strong>
                        <br />
                        {flight.CHSTOL.slice(5, 10).split("-")[1] +
                          "/" +
                          flight.CHSTOL.slice(5, 10).split("-")[0]}
                      </td>
                      <td>{flight.CHPTOL.slice(11, 16)}</td>
                      <td>{flight.CHRMINE}</td>
                    </tr>
                  ))
                ) : (
                  <p>Loading...</p>
                )}
              </tbody>
            </table>
          </div>
          <div className="clear"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default LiveLandingBoard;



// WEBPACK FOOTER //
// ./src/Pages/LiveLandingBoard/LiveLandingBoard.js